import { UnsavedChangesModal, type UnsavedChangesModalProps } from '@app/components'
import { Stepper, type StepperProps } from '@mantine/core'
import { type FC, type ReactNode, useCallback, useState } from 'react'

export interface WizardModalChildrenProps {
  setStep(step: number): void
  step: number
}

export interface WizardModalProps extends Omit<UnsavedChangesModalProps, 'children'> {
  children: (props: WizardModalChildrenProps) => ReactNode
  stepCount: number
  stepperProps?: Omit<StepperProps, 'active' | 'children' | 'onStepClick'>
}

export const WizardModal: FC<WizardModalProps> = ({ children, onClose, stepCount, stepperProps, ...props }) => {
  const [step, setStep] = useState(0)

  return (
    <UnsavedChangesModal
      onClose={useCallback(() => {
        onClose()
        setTimeout(() => setStep(0), 0)
      }, [onClose])}
      {...props}
    >
      <Stepper
        active={step}
        onStepClick={setStep}
        {...stepperProps}
      >
        {/* this is a render method called "render props", see for more information:
         https://reactjs.org/docs/render-props.html#using-props-other-than-render */}
        {children({ setStep, step })}
      </Stepper>
    </UnsavedChangesModal>
  )
}
